import { useEffect } from "react";
import { useRouteError } from "react-router";
import { captureException } from "@/sentry";
import ErrorFallback from "@/components/ErrorFallback";

/**
 * Error boundary for the route tree.
 *
 * A data router keeps errors thrown inside route subtrees to itself — it
 * renders its own built-in error page rather than rethrowing, so the
 * <Sentry.ErrorBoundary> around <RouterProvider> never sees them. Without this
 * the user gets react-router's developer screen, stack trace and all, and
 * nothing reaches Sentry.
 */
const RouteErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    // captureException no-ops without a DSN, which is the local case, so log
    // as well — otherwise a crash leaves nothing behind to debug.
    console.error("Unhandled route error:", error);
    captureException(error, { source: "RouteErrorBoundary" });
  }, [error]);

  return <ErrorFallback />;
};

export default RouteErrorBoundary;
